import { Grid } from "@mui/material";
import { BARRIOS_COMUNAS, ESTADOS_PROPIEDAD } from "../../utils/constants";
import { getPropiedadesPaginadas } from "../../action";
import { useDispatch, useSelector } from "react-redux";
import { Field, Form, Formik } from "formik";
import ComunaTreeSelect from "../common/ComunaTreeSelect";

const FiltroPropiedades = ({
  page,
  rowsPerPage,
  sortBy,
  filtroValues,
  setFiltroValues,
  buscador,
  storageKeyPrefix,
  setPage,
  setBuscador,
}) => {
  const dispatch = useDispatch();
  const userData = useSelector((state) => state.app.itemUsuario);
  const brokers = useSelector((state) => state.app.usuariosFiltrados);

  const handleSubmit = (formValues) => {
    localStorage.setItem(`${storageKeyPrefix}tipoOperacion`, formValues.tipoOperacion);
    localStorage.setItem(`${storageKeyPrefix}tipoPropiedad`, formValues.tipoPropiedad);
    localStorage.setItem(`${storageKeyPrefix}comuna`, formValues.comuna);
    localStorage.setItem(`${storageKeyPrefix}DormitoriosDesde`, formValues.dormitoriosDesde);
    localStorage.setItem(`${storageKeyPrefix}DormitoriosHasta`, formValues.dormitoriosHasta);
    localStorage.setItem(`${storageKeyPrefix}BaniosDesde`, formValues.baniosDesde);
    localStorage.setItem(`${storageKeyPrefix}BaniosHasta`, formValues.baniosHasta);
    localStorage.setItem(`${storageKeyPrefix}codigoPropiedad`, formValues.codigoPropiedad);
    localStorage.setItem(`${storageKeyPrefix}SuperficieTotalDesde`, formValues.superficieTotalDesde);
    localStorage.setItem(`${storageKeyPrefix}SuperficieTotalHasta`, formValues.superficieTotalHasta);
    localStorage.setItem(`${storageKeyPrefix}SuperficieUtilDesde`, formValues.superficieUtilDesde);
    localStorage.setItem(`${storageKeyPrefix}SuperficieUtilHasta`, formValues.superficieUtilHasta);
    localStorage.setItem(`${storageKeyPrefix}Estado`, formValues.estadoPropiedad);
    localStorage.setItem(`${storageKeyPrefix}TipoMoneda`, formValues.tipoMoneda);
    localStorage.setItem(`${storageKeyPrefix}Estacionamientos`, formValues.estacionamiento);
    localStorage.setItem(`${storageKeyPrefix}Bodegas`, formValues.bodega);
    localStorage.setItem(`${storageKeyPrefix}valorDesde`, formValues.valorDesde);
    localStorage.setItem(`${storageKeyPrefix}valorHasta`, formValues.valorHasta);
    localStorage.setItem(`${storageKeyPrefix}broker`, formValues.idBroker);
    setPage(0);
    setFiltroValues(formValues);
    dispatch(
      getPropiedadesPaginadas(
        formValues.estadoPropiedad,
        formValues.idBroker,
        page,
        rowsPerPage,
        "todos",
        sortBy,
        formValues.comuna,
        formValues.tipoPropiedad,
        formValues.tipoOperacion,
        formValues.valorDesde,
        formValues.valorHasta,
        formValues.baniosDesde,
        formValues.baniosHasta,
        formValues.dormitoriosDesde,
        formValues.dormitoriosHasta,
        formValues.superficieUtilDesde,
        formValues.superficieUtilHasta,
        formValues.superficieTotalDesde,
        formValues.superficieTotalHasta,
        formValues.codigoPropiedad,
        formValues.tipoMoneda,
        "",
        buscador,
        formValues.estacionamiento,
        formValues.bodega
      )
    );
  };

  const limpiarFiltros = (formValues) => {
    const valoresLimpios = {
      tipoOperacion: "",
      tipoPropiedad: "",
      comuna: "",
      dormitoriosDesde: "0",
      dormitoriosHasta: "0",
      baniosDesde: "0",
      baniosHasta: "0",
      codigoPropiedad: "",
      superficieTotalDesde: "0",
      superficieTotalHasta: "0",
      superficieUtilDesde: "0",
      superficieUtilHasta: "0",
      estadoPropiedad: "",
      tipoMoneda: "",
      estacionamiento: "0",
      bodega: "0",
      valorDesde: "0",
      valorHasta: "0",
      idBroker: userData.tipoCuenta === 10 ? userData.userId : "",
    };

    localStorage.setItem(`${storageKeyPrefix}tipoOperacion`, "");
    localStorage.setItem(`${storageKeyPrefix}tipoPropiedad`, "");
    localStorage.setItem(`${storageKeyPrefix}comuna`, "");
    localStorage.setItem(`${storageKeyPrefix}DormitoriosDesde`, "0");
    localStorage.setItem(`${storageKeyPrefix}DormitoriosHasta`, "0");
    localStorage.setItem(`${storageKeyPrefix}BaniosDesde`, "0");
    localStorage.setItem(`${storageKeyPrefix}BaniosHasta`, "0");
    localStorage.setItem(`${storageKeyPrefix}codigoPropiedad`, "");
    localStorage.setItem(`${storageKeyPrefix}SuperficieTotalDesde`, "0");
    localStorage.setItem(`${storageKeyPrefix}SuperficieTotalHasta`, "0");
    localStorage.setItem(`${storageKeyPrefix}SuperficieUtilDesde`, "0");
    localStorage.setItem(`${storageKeyPrefix}SuperficieUtilHasta`, "0");
    localStorage.setItem(`${storageKeyPrefix}Estado`, "");
    localStorage.setItem(`${storageKeyPrefix}TipoMoneda`, "");
    localStorage.setItem(`${storageKeyPrefix}Estacionamientos`, "0");
    localStorage.setItem(`${storageKeyPrefix}Bodegas`, "0");
    localStorage.setItem(`${storageKeyPrefix}valorDesde`, "0");
    localStorage.setItem(`${storageKeyPrefix}valorHasta`, "0");
    localStorage.setItem(`${storageKeyPrefix}idBroker`, userData.tipoCuenta === 10 ? userData.userId : "");
    setPage(0);
    setFiltroValues(valoresLimpios);
    setBuscador("");
    if (userData) {
      dispatch(
        getPropiedadesPaginadas(
          "",
          userData.tipoCuenta === 10 ? userData.userId : "",
          page,
          rowsPerPage,
          "todos",
          sortBy,
          "",
          "",
          "",
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          "",
          "",
          "",
          "",
          0,
          0
        )
      );
    };
  };

  let estadosOptions = [];
  //estadosOptions.push({ value: null, label: "- Seleccione -" });
  Object.keys(ESTADOS_PROPIEDAD).forEach((k) => {
    estadosOptions.push({ value: k, label: ESTADOS_PROPIEDAD[k] });
  });



  const handleResetCustom = (formValues) => {
    limpiarFiltros(formValues);
  };

  return (
    <div style={{ marginBottom: "10px" }}>
      <Formik
        initialValues={filtroValues}
        onSubmit={handleSubmit}
        enableReinitialize={true}
      >
        {({ values, handleSubmit, setFieldValue }) => (
          <Form onSubmit={handleSubmit}>
            <Grid container spacing={1} justifyContent={"space-between"}>
              <Grid item xs={6} sm={4} md={4} lg={4} xl={3}>
                <label className="milabel">Operación</label>
                <Field name="tipoOperacion" as="select" className="miSelect">
                  <option value={""}>- Seleccione -</option>
                  <option value="arriendo">Arriendo</option>
                  <option value="venta">Venta</option>
                </Field>
              </Grid>
              <Grid item xs={6} sm={4} md={4} lg={4} xl={3}>
                <label className="milabel">Tipo inmueble</label>
                <Field name="tipoPropiedad" as="select" className="miSelect">
                  <option value={""}>- Seleccione -</option>
                  <option value="Departamento">Departamento</option>
                  <option value="Casa">Casa</option>
                  <option value="Oficina">Oficina</option>
                  <option value="Terreno">Terreno</option>
                  <option value="Local">Local</option>
                </Field>
              </Grid>
              <Grid item xs={6} sm={4} md={4} lg={4} xl={3}>
                <label className="milabel">Comuna</label>
                <ComunaTreeSelect
                  value={values.comuna}
                  onChange={(val) => setFieldValue("comuna", val)}
                  className="miSelect"
                />
              </Grid>
              <Grid item xs={6} sm={4} md={4} lg={4} xl={3}>
                <label className="milabel">Dormitorios</label>
                <Grid container spacing={1}>
                  <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
                    <Field
                      name="dormitoriosDesde"
                      placeholder="Desde"
                      type="text"
                      className="miSelect"
                    />
                  </Grid>
                  <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
                    <Field
                      name="dormitoriosHasta"
                      placeholder="Hasta"
                      type="text"
                      className="miSelect"
                    />
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={6} sm={4} md={4} lg={4} xl={3}>
                <label className="milabel">Baños</label>
                <Grid container spacing={1}>
                  <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
                    <Field
                      name="baniosDesde"
                      placeholder="Desde"
                      type="text"
                      className="miSelect"
                    />
                  </Grid>
                  <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
                    <Field
                      name="baniosHasta"
                      placeholder="Hasta"
                      type="text"
                      className="miSelect"
                    />
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={6} sm={4} md={4} lg={4} xl={3}>
                <label className="milabel">Código propiedad</label>
                <Field
                  name="codigoPropiedad"
                  type="text"
                  className="miSelect"
                />
              </Grid>
              <Grid item xs={6} sm={4} md={4} lg={4} xl={3}>
                <label className="milabel">Superficie total</label>
                <Grid container spacing={1}>
                  <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
                    <Field
                      name="superficieTotalDesde"
                      placeholder="Desde"
                      type="text"
                      className="miSelect"
                    />
                  </Grid>
                  <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
                    <Field
                      name="superficieTotalHasta"
                      placeholder="Hasta"
                      type="text"
                      className="miSelect"
                    />
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={6} sm={4} md={4} lg={4} xl={3}>
                <label className="milabel">Superficie útil</label>
                <Grid container spacing={1}>
                  <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
                    <Field
                      name="superficieUtilDesde"
                      placeholder="Desde"
                      type="text"
                      className="miSelect"
                    />
                  </Grid>
                  <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
                    <Field
                      name="superficieUtilHasta"
                      placeholder="Hasta"
                      type="text"
                      className="miSelect"
                    />
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={6} sm={4} md={4} lg={4} xl={3}>
                <label className="milabel">Tipo moneda</label>
                <Field name="tipoMoneda" as="select" className="miSelect">
                  <option value={""}>- Seleccione -</option>
                  <option value="CLP">CLP</option>
                  <option value="UF">UF</option>
                </Field>
              </Grid>
              <Grid item xs={6} sm={4} md={4} lg={4} xl={3}>
                <label className="milabel">Valor</label>
                <Grid container spacing={1}>
                  <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
                    <Field
                      name="valorDesde"
                      placeholder="Desde"
                      type="text"
                      className="miSelect"
                    />
                  </Grid>
                  <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
                    <Field
                      name="valorHasta"
                      placeholder="Hasta"
                      type="text"
                      className="miSelect"
                    />
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12} sm={8} md={4} lg={4} xl={3}>
                <Grid container spacing={1}>
                  <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
                    <label className="milabel">Estacionamientos</label>
                    <Field
                      name="estacionamiento"
                      type="text"
                      className="miSelect"
                    />
                  </Grid>
                  <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
                    <label className="milabel">Bodegas</label>
                    <Field name="bodega" type="text" className="miSelect" />
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12} sm={8} md={4} lg={4} xl={3}>
                <label className="milabel">Estado propiedad</label>
                <Field name="estadoPropiedad" as="select" className="miSelect">
                  <option value={""}>- Seleccione -</option>
                  {estadosOptions.map((c) => (
                    <option value={c.value}>{c.label}</option>
                  ))}
                </Field>
              </Grid>
              {userData &&
                userData.tipoCuenta !== 10 &&
                window.location.pathname.includes("mispropiedades") && (
                  <Grid item xs={12} sm={6} md={6} lg={4} xl={3}>
                    <label className="milabel">Broker</label>
                    <Field name="idBroker" as="select" className="miSelect">
                      <option value={""}>- Seleccione -</option>
                      {brokers &&
                        brokers.length > 0 &&
                        brokers.map((c) => (
                          <option value={c.id}>
                            {c.nombres} {c.apellidos}
                          </option>
                        ))}
                    </Field>
                  </Grid>
                )}
              <Grid item>
                <button
                  type="submit"
                  className="boton2"
                  style={{ margin: "10px" }}
                //onClick={() => filtrar()}
                >
                  Filtrar
                </button>
                <button
                  type="button"
                  className="boton-gris"
                  style={{ margin: "10px" }}
                  onClick={() => handleResetCustom(values)}
                >
                  Limpiar filtros
                </button>
              </Grid>
            </Grid>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default FiltroPropiedades;
